import React, { useState, useEffect } from 'react';
import logo from '../assets/images/logo/logo.png';
import backgroundImage from '../assets/images/home/oryzalanding.webp'; 
import oryzaImage from '../assets/images/home/oryzalanding.webp';
import pettiImage from '../assets/images/home/pettipetti.webp';
import kentImage from '../assets/images/home/kent.webp';
import kandyImage from '../assets/images/home/bbkandy.webp';
import mirissaImage from '../assets/images/home/bbmirissa.webp';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [destinationsPopupOpen, setDestinationsPopupOpen] = useState(false);
  const [hoveredDestination, setHoveredDestination] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  useEffect(() => {
    console.log('destinationsPopupOpen state:', destinationsPopupOpen);
  }, [destinationsPopupOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDestinationsPopup = (e) => {
    e.preventDefault();
    console.log('Toggling Destinations Popup');
    setDestinationsPopupOpen(prev => {
      const newState = !prev;
      console.log('New popup state:', newState);
      return newState;
    });
  };

  const closePopup = () => {
    console.log('Closing Popup');
    setDestinationsPopupOpen(false);
    setHoveredDestination(null);
  };

  const handleDestinationHover = (destinationKey) => {
    setHoveredDestination(destinationKey);
  };

  const handleDestinationLeave = () => {
    setHoveredDestination(null);
  };

  // Destination data mapping
  const destinations = {
    oryza: {
      title: 'ORYZA LEISURE',
      href: '/oryza',
      image: oryzaImage
    },
    petti: {
      title: 'PETTI PETTI MIRISSA',
      href: '/pettipettimirissa',
      image: pettiImage
    },
    kent: {
      title: 'KENT COTTAGE NUWARA ELIYA',
      href: '/kent/home',
      image: kentImage
    },
    kandy: {
      title: 'BANANA BUNKS KANDY',
      href: '/BananaBunksKandy',
      image: kandyImage
    },
    mirissa: {
      title: 'BANANA BUNKS MIRISSA',
      href: '/',
      image: mirissaImage
    }
  };

  const navbarStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    padding: '20px 0',
    transition: 'all 0.3s ease',
    zIndex: 1000,
    backgroundColor: scrolled ? '#5a594f' : 'transparent',
    boxShadow: scrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : 'none'
  };

  const navbarContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1882px',
    margin: '0 auto',
    padding: '0 20px'
  };

  const logoContainerStyle = {
    display: 'flex',
    alignItems: 'center',
  };

  const logoStyle = {
    width: '50px',
    height: 'auto'
  };

  const destinationsDropdownStyle = {
    position: 'relative',
    cursor: 'pointer',
    marginLeft: '120px',
    zIndex: 1001
  };

  const dropdownBtnStyle = {
    background: 'none',
    border: 'none',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '1.5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.3s ease',
    whiteSpace: 'nowrap',
    outline: 'none',
    pointerEvents: 'auto'
  };

  const dropdownIconStyle = {
    fontSize: '10px',
    marginLeft: '8px'
  };

  const navLinksStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
    flex: 1
  };

  const navLinkStyle = {
    color: 'white',
    textDecoration: 'none',
    margin: '0 12px',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '1.5px',
    transition: 'color 0.3s ease',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  };

  const bookBtnStyle = {
    color: 'white',
    textDecoration: 'none',
    border: '1px solid white',
    padding: '8px 18px',
    marginLeft: '12px',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '1.5px',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  };

  const hamburgerStyle = {
    display: 'none',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '30px',
    height: '25px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    zIndex: '10'
  };

  const hamburgerLineStyle = {
    width: '30px',
    height: '3px',
    backgroundColor: 'white',
    borderRadius: '10px',
    transition: 'all 0.3s linear'
  };

  const mobileMenuStyle = {
    display: mobileMenuOpen ? 'flex' : 'none',
    flexDirection: 'column',
    position: 'fixed',
    top: '0',
    right: '0',
    height: '100vh',
    width: '100%',
    zIndex: '9',
    transition: 'transform 0.3s ease-in-out',
    transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)'
  };

  const mobileMenuHeaderStyle = {
    backgroundColor: '#5a594f',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px',
    height: '80px',
  };

  const mobileLogoStyle = {
    width: '50px',
    height: 'auto'
  };

  const mobileCloseButtonStyle = {
    fontSize: '24px',
    color: '#eeb85e',
    background: 'none',
    border: 'none',
    cursor: 'pointer'
  };

  const mobileMenuContentStyle = {
    backgroundColor: '#eeb85e',
    padding: '20px',
    height: 'calc(100% - 80px)',
    display: 'flex',
    flexDirection: 'column'
  };

  const mobileLinkStyle = {
    color: '#5a594f',
    textDecoration: 'none',
    margin: '10px 0',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '18px',
    fontWeight: 600,
    letterSpacing: '1px',
    transition: 'color 0.3s ease'
  };

  const mobileContactStyle = {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column'
  };

  const mobileContactTitleStyle = {
    color: '#5a594f',
    fontSize: '12px',
    fontWeight: 400,
    marginBottom: '5px',
    letterSpacing: '1px'
  };

  const mobileContactNumberStyle = {
    color: '#5a594f',
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center'
  };

  const mobileFooterTextStyle = {
    color: '#5a594f',
    fontSize: '12px',
    fontWeight: 400,
    marginTop: '10px'
  };

  const bookYourStayStyle = {
    color: '#5a594f',
    textDecoration: 'none',
    margin: '10px 0',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '18px',
    fontWeight: 700,
    letterSpacing: '1px',
    transition: 'color 0.3s ease'
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 1024);
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const getCurrentBackgroundImage = () => {
    if (hoveredDestination && destinations[hoveredDestination]) {
      return destinations[hoveredDestination].image;
    }
    return backgroundImage;
  };

  const destinationsPopupStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundImage: `linear-gradient(rgba(124, 122, 122, 0.4), rgba(124, 122, 122, 0.4)), url(${getCurrentBackgroundImage()})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: 9999,
    display: destinationsPopupOpen ? 'block' : 'none',
    opacity: destinationsPopupOpen ? 1 : 0,
    visibility: destinationsPopupOpen ? 'visible' : 'hidden',
    transition: 'opacity 0.3s ease, visibility 0.3s ease, background-image 0.3s ease'
  };

  const popupNavbarStyle = {
    ...navbarStyle,
    backgroundColor: '#5a594f',
    width: '100%',
    padding: isMobile ? '10px 20px' : '20px 0',
    zIndex: 10000,
    position: 'relative'
  };

  const panelContentStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: isMobile ? '20px' : '50px 0',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    minHeight: 'calc(100vh - 90px)'
  };

  const containerItemStyle = {
    marginBottom: '30px',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  };

  const linkStyle = {
    color: 'white',
    textDecoration: 'none',
    fontSize: isMobile ? '18px' : '28px',
    fontWeight: 600,
    letterSpacing: '2px',
    textTransform: 'uppercase',
    transition: 'all 0.3s ease',
    display: 'block',
    marginBottom: '15px',
    fontFamily: 'Poppins, sans-serif',
    lineHeight: isMobile ? '20px' : '48px',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
  };

  const menuPanelDetailsStyle = {
    width: '100%',
    textAlign: isMobile ? 'center' : 'left'
  };

  const contactHeaderStyle = {
    fontSize: isMobile ? '16px' : '20px',
    fontWeight: 600,
    marginBottom: '20px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif'
  };

  const contactsListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    marginBottom: '30px'
  };

  const contactItemStyle = {
    margin: '8px 0'
  };

  const contactLinkStyle = {
    color: 'white',
    textDecoration: 'none',
    fontSize: isMobile ? '14px' : '16px',
    transition: 'color 0.3s ease',
    fontFamily: 'Poppins, sans-serif'
  };

  const socialListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'flex-start',
    gap: '15px'
  };

  const socialItemStyle = {
    margin: '0'
  };

  const socialLinkStyle = {
    color: 'white',
    fontSize: '24px',
    transition: 'color 0.3s ease'
  };

  const panelContentWrapperStyle = {
    width: '100%',
    maxWidth: '1300px',
    margin: '0 auto',
    padding: isMobile ? '0 20px' : '0 50px'
  };

  const containerStyle = {
    width: '100%'
  };

  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'center' : 'flex-start',
    flexDirection: isMobile ? 'column' : 'row',
    flexWrap: 'nowrap',
    gap: isMobile ? '30px' : '80px'
  };

  const leftColumnStyle = {
    flex: isMobile ? 'none' : '0 0 60%',
    width: isMobile ? '100%' : 'auto',
    paddingLeft: isMobile ? '0' : '50px',
    textAlign: isMobile ? 'center' : 'left'
  };

  const rightColumnStyle = {
    flex: isMobile ? 'none' : '0 0 35%',
    width: isMobile ? '100%' : 'auto',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: '20px'
  };

  const wrapperMenuStyle = {
    width: '100%'
  };

  const menuListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '10px' : '15px',
    alignItems: isMobile ? 'center' : 'flex-start'
  };

  const renderNavbar = (isPopup = false) => (
    <nav style={isPopup ? popupNavbarStyle : navbarStyle}>
      <div style={navbarContainerStyle}>
        <div style={logoContainerStyle}>
          <a href="/">
            <img src={logo} alt="Banana Bunks Logo" style={logoStyle} />
          </a>
          {!isMobile && (
            <div style={destinationsDropdownStyle}>
              <button 
                style={dropdownBtnStyle} 
                onClick={toggleDestinationsPopup}
                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                onMouseOut={(e) => e.target.style.color = 'white'}
              >
                DESTINATIONS
                <span style={dropdownIconStyle}>▼</span>
              </button>
            </div>
          )}
          {isMobile && (
            <div style={destinationsDropdownStyle}>
              <button 
                style={dropdownBtnStyle} 
                onClick={toggleDestinationsPopup}
                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                onMouseOut={(e) => e.target.style.color = 'white'}
              >
                DESTINATIONS
                <span style={dropdownIconStyle}>▼</span>
              </button>
            </div>
          )}
        </div>

        {!isMobile ? (
          <div style={navLinksStyle}>
            <a 
              href="/" 
              style={navLinkStyle}
              onMouseOver={(e) => e.target.style.color = '#eeb85e'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              HOME
            </a>
            <a 
              href="/bbmirissa/room" 
              style={navLinkStyle}
              onMouseOver={(e) => e.target.style.color = '#eeb85e'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              ROOMS & BUNKS
            </a>
            <a 
              href="/bbmirissa/gallery" 
              style={navLinkStyle}
              onMouseOver={(e) => e.target.style.color = '#eeb85e'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              GALLERY
            </a>
            <a 
              href="/bbmirissa/offers" 
              style={navLinkStyle}
              onMouseOver={(e) => e.target.style.color = '#eeb85e'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              OFFERS
            </a>
            <a 
              href="/bbmirissa/about" 
              style={navLinkStyle}
              onMouseOver={(e) => e.target.style.color = '#eeb85e'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              ABOUT US
            </a>
            <a 
              href="/bbmirissa/contactus" 
              style={navLinkStyle}
              onMouseOver={(e) => e.target.style.color = '#eeb85e'}
              onMouseOut={(e) => e.target.style.color = 'white'}
            >
              CONTACT US
            </a>
            <a 
              href="https://live.ipms247.com/booking/book-rooms-bananabunksmirissa" 
              style={{...bookBtnStyle}}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#eeb85e';
                e.target.style.borderColor = '#eeb85e';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.borderColor = 'white';
              }}
            >
              BOOK YOUR STAY
            </a>
          </div>
        ) : (
          <>
            {!mobileMenuOpen && (
              <button onClick={toggleMobileMenu} style={{...hamburgerStyle, display: 'flex'}}>
                <div style={hamburgerLineStyle}></div>
                <div style={hamburgerLineStyle}></div>
                <div style={hamburgerLineStyle}></div>
              </button>
            )}
            
            <div style={mobileMenuStyle}>
              <div style={mobileMenuHeaderStyle}>
                <img src={logo} alt="Banana Bunks Logo" style={mobileLogoStyle} />
                <button onClick={toggleMobileMenu} style={mobileCloseButtonStyle}>
                  ×
                </button>
              </div>
              
              <div style={mobileMenuContentStyle}>
                <a href="/" style={mobileLinkStyle}>HOME</a>
                <a href="bbmirissa/room" style={mobileLinkStyle}>ROOMS & BUNKS</a>
                <a href="bbmirissa/offers" style={mobileLinkStyle}>OFFERS</a>
                <a href="bbmirissa/gallery" style={mobileLinkStyle}>GALLERY</a>
                <a href="bbmirissa/aboutus" style={mobileLinkStyle}>ABOUT US</a>
                <a href="bbmirissa/contactus" style={mobileLinkStyle}>CONTACT US</a>
                <a href="https://live.ipms247.com/booking/book-rooms-bananabunksmirissa" style={bookYourStayStyle}>BOOK YOUR STAY</a>
                
                <div style={mobileContactStyle}>
                  <div style={mobileContactTitleStyle}>CONTACT US</div>
                  <div style={mobileContactNumberStyle}>
                    <span style={{marginRight: '10px'}}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.908.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="#5a594f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </span>
                    +94 76 700 8800
                  </div>
                  <div style={mobileFooterTextStyle}>
                    Designed and Developed by
                    <div style={{fontWeight: 700, marginTop: '5px'}}>OLLCODE</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );

  return (
    <>
      {renderNavbar()}
      {destinationsPopupOpen && (
        <div style={destinationsPopupStyle}>
          {renderNavbar(true)}
          <div style={panelContentStyle}>
            <div style={panelContentWrapperStyle}>
              <div style={containerStyle}>
                <div style={rowStyle}>
                  <div style={leftColumnStyle}>
                    <nav style={wrapperMenuStyle}>
                      <ul style={menuListStyle}>
                        {Object.entries(destinations).map(([key, destination]) => (
                          <li key={key}>
                            <div 
                              style={containerItemStyle}
                              onMouseEnter={() => handleDestinationHover(key)}
                              onMouseLeave={handleDestinationLeave}
                            >
                              <a 
                                href={destination.href}
                                style={{
                                  ...linkStyle,
                                  color: hoveredDestination === key ? 'white' : '#848484',
                                  transform: hoveredDestination === key ? 'translateX(20px)' : 'translateX(0)',
                                }}
                                onClick={closePopup}
                              >
                                {destination.title}
                              </a>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                  <div style={rightColumnStyle}>
                    <div style={menuPanelDetailsStyle}>
                      <div>
                        <h5 style={contactHeaderStyle}>Contact Us</h5>
                        <div>
                          <ul style={contactsListStyle}>
                            <li style={contactItemStyle}>
                              <a 
                                href="tel:+94767008800" 
                                style={contactLinkStyle}
                                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                                onMouseOut={(e) => e.target.style.color = 'white'}
                              >
                                +94 76 700 8800
                              </a>
                            </li>
                            <li style={contactItemStyle}>
                              <a 
                                href="mailto:hello@oryzaleisure.com" 
                                style={contactLinkStyle}
                                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                                onMouseOut={(e) => e.target.style.color = 'white'}
                              >
                                reservations@oryzaleisure.com
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div>
                          <ul style={socialListStyle}>
                            <li style={socialItemStyle}>
                              <a 
                                href="https://www.facebook.com/pettipettimirissa" 
                                style={socialLinkStyle}
                                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                                onMouseOut={(e) => e.target.style.color = 'white'}
                              >
                                <i className="bi bi-facebook"></i>
                              </a>
                            </li>
                            <li style={socialItemStyle}>
                              <a 
                                href="https://www.instagram.com/oryzaleisure" 
                                style={socialLinkStyle}
                                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                                onMouseOut={(e) => e.target.style.color = 'white'}
                              >
                                <i className="bi bi-instagram"></i>
                              </a>
                            </li>
                            <li style={socialItemStyle}>
                              <a 
                                href="https://wa.me/94767008800" 
                                style={socialLinkStyle}
                                onMouseOver={(e) => e.target.style.color = '#eeb85e'}
                                onMouseOut={(e) => e.target.style.color = 'white'}
                              >
                                <i className="bi bi-whatsapp"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;